(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8237,682],{

/***/ 8237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ BackgroundImageWithRightTextLeftButton; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(682);
/* harmony import */ var _BackgroundImageWithRightTextLeftButton_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5450);
/* harmony import */ var _BackgroundImageWithRightTextLeftButton_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_BackgroundImageWithRightTextLeftButton_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _shared_Button_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8122);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5893);








function BackgroundImageWithRightTextLeftButton(_ref) {
  var backgroundPath = _ref.backgroundPath,
      primaryText = _ref.primaryText,
      secondaryText = _ref.secondaryText,
      data = _ref.data,
      _ref$buttonColor = _ref.buttonColor,
      buttonColor = _ref$buttonColor === void 0 ? "black" : _ref$buttonColor,
      _ref$buttonShape = _ref.buttonShape,
      buttonShape = _ref$buttonShape === void 0 ? "round" : _ref$buttonShape;

  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)(),
      locale = _useRouter.locale;

  var dir = locale === "ar" ? "rtl" : "ltr";
  var ctaText = locale === "ar" ? "تواصل معنا الآن" : "contact us now";
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__["default"], {
    fluid: true,
    style: {
      padding: "0"
    },
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
      className: (_BackgroundImageWithRightTextLeftButton_module_scss__WEBPACK_IMPORTED_MODULE_6___default().background),
      dir: dir,
      style: {
        backgroundImage: "url(".concat(backgroundPath, ")"),
        backgroundPosition: "top right",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat"
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: (_BackgroundImageWithRightTextLeftButton_module_scss__WEBPACK_IMPORTED_MODULE_6___default().content),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          className: (_BackgroundImageWithRightTextLeftButton_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["overlay-text"]),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
            className: (_BackgroundImageWithRightTextLeftButton_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["text-content"]),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("h3", {
              className: (_BackgroundImageWithRightTextLeftButton_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["primary-text"]),
              children: primaryText
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("p", {
              className: (_BackgroundImageWithRightTextLeftButton_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["secondary-text"]),
              children: secondaryText
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
            className: (_BackgroundImageWithRightTextLeftButton_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["cta-wrapper"]),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
              href: "/contactus",
              legacyBehavior: true,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
                className: (_BackgroundImageWithRightTextLeftButton_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["cta-link"]),
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_shared_Button_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                  buttonText: ctaText,
                  buttonColor: buttonColor,
                  buttonShape: buttonShape
                })
              })
            })
          })]
        })
      })
    })
  });
}

/***/ }),

/***/ 5450:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"background":"BackgroundImageWithRightTextLeftButton_background__SxfcQ","content":"BackgroundImageWithRightTextLeftButton_content__B8NKw","overlay-text":"BackgroundImageWithRightTextLeftButton_overlay-text__OKGiA","text-content":"BackgroundImageWithRightTextLeftButton_text-content__1m3qn","cta-wrapper":"BackgroundImageWithRightTextLeftButton_cta-wrapper__aPRkc","cta-link":"BackgroundImageWithRightTextLeftButton_cta-link__ntO9G","button":"BackgroundImageWithRightTextLeftButton_button__7ETyj","right":"BackgroundImageWithRightTextLeftButton_right__qOjhz","left":"BackgroundImageWithRightTextLeftButton_left__G4nK8"};

/***/ }),

/***/ 682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);
"use client";





const Container = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  fluid = false,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  className,
  ...props
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'container');
  const suffix = typeof fluid === 'string' ? `-${fluid}` : '-fluid';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, fluid ? `${prefix}${suffix}` : prefix)
  });
});
Container.displayName = 'Container';
/* harmony default export */ __webpack_exports__["default"] = (Container);

/***/ })

}]);